<template>
	<div class="content">
		<div class="content_head">
			<p>
				<input type="text" @keypress="searchCustomers" placeholder="会员手机号|扫描会员二维码" class="search"
					v-model="searchText" />
				<button type="button" class="button" :class="{'disabled':searchText==''}" :disabled="searchText.length<=1"
					@click="getReturnBookByCustomerCode()" title="点击查找会员">查询会员</button>
			</p>
			<p>
				会员信息: <span v-if="customer!=null" class="red">
					{{ customer.CustomerName +' '+ customer.CustomerPhone }}
					&nbsp; &nbsp; &nbsp;&nbsp;
					账号押金:{{customer.Deposit+'元' }}
					&nbsp; &nbsp; &nbsp;&nbsp;
					可借数量:{{customer.booksCount+'本' }}
					&nbsp; &nbsp; &nbsp;&nbsp;
					待还数量:{{customer.borrowBooksCount+'本' }}
					&nbsp; &nbsp; &nbsp;&nbsp;
					可借数量:{{customer.booksCount -customer.borrowBooksCount +'本'}}
					&nbsp; &nbsp; &nbsp;&nbsp;
					到期时间:{{ $moment (customer.VipEndDate).format('YYYY年MM月DD日') }}
					&nbsp; &nbsp; &nbsp;&nbsp;
					办理店铺:{{customer.ShopName }}
				</span>
			</p>
			<p>
				<hr style="color: blue;" />
			</p>
		</div>
		<div class="content_body">

			<div>
				<table>
					<thead>
						<tr>
							<td>序号</td>
							<th>书籍名称</th>
							<td>
								借书详情
							</td>
							<td>
								还书详情
							</td>
							<td>
								操作
							</td>

						</tr>
					</thead>
					<tbody>
						<tr v-for="(y,index) in books">
							<td>{{index+1}}</td>
							<td>
								{{y.BooksName}}
							</td>
							<td>
								<p class="left lineHeight_2">
									借出编号:
									<span class="red"> {{ y.BooksNumCode}}
									</span><br />
									图书价格:
									<span class="red">{{y.BookPrice |rmb}}
									</span><br />
									借出店铺:
									<span class="red">{{y.ShopName}}
									</span><br />
									借出位置:
									<span class="red">{{y.BorrowOutPlace}}
									</span><br />
									借出时间:
									<span class="red">{{y.BorrowDate}}
									</span><br />
									借出时间:
									<span class="red">{{getDay(y.BorrowDate)}}
									</span><br />
								</p>
							</td>
							<td>
								<p class="left lineHeight_2">
									支付费用:
									<input type="text" v-model="y.payMoney" />
									</span><br />
									还书店铺:
									<span
										class="red">{{y.ReturnShopName==""?$store.state.shopName:y.ReturnShopName}}</span><br />

									还书备注:
									<textarea style="vertical-align: text-top;" placeholder="异常备注必须填写(10字以上)"
										v-model="y.Remarks"></textarea>

								</p>

							</td>
							<td>
								<button class="button" :disabled="y.Remarks.length<10"
									:class="{'disabled':y.Remarks.length<10}" @click="returnBooks(y)">确认还书</button>
							</td>

						</tr>

					</tbody>
				</table>

			</div>

		</div>

	</div>

</template>

<script>
	export default {
		name: 'abnormal',
		data() {
			return {
				payMoney: 0,
				payType: 1,
				searchText: '',
				searchBookCode: '',
				getReturnBookByCustomerCode: {},
				getBook: {},
				customer: null,
				books: [],
				borrowCount: 0,
				returnCount: 0,
				getDay: {},
				OperatorID: this.$store.state.user.UserID,
				ShopID: this.$store.state.user.ShopID
			}
		},
		created() {
			this.getDay = function(v) {
				let date = new Date(v.replace(/-/g, '/'));
				let now = new Date();
				return Math.ceil((now - date) / 1000 / 60 / 60 / 24) + '天';
			}

			this.getReturnBookByCustomerCode = function() {
				this.$request.request({
					url: 'borrowAndReturn/getabnormal',
					data: {
						searchText: this.searchText
					},
					method: 'post'

				}).then(res => {
					if (res.result) {
						this.customer = res.customer;
						this.searchText = this.customer.CustomerPhone;
						this.books = res.books;
						for (let i of this.books)
							i.payMoney = 0;
					} else {
						this.$uil.showMessage({
							text: res.message
						});
					}
				})
			}



		},
		methods: {
			searchCustomers(e) {
				if (e.keyCode == 13)
					this.getReturnBookByCustomerCode();
			},
			returnBooks(i) {
				this.$request.request({
					url: 'borrowAndReturn/abnormalReturn',
					data: {
						BookDetailID: i.BookDetailID,
						OrderID: i.CustomerOrderID,
						CustomerOrderBooksDetailID: i.CustomerOrderBooksDetailID,
						remarks: i.Remarks,
						ShopID: this.$store.state.user.ShopID,
						OperatorID: this.$store.state.user.UserID,
						PayMoney:i.payMoney
					},
					method: 'post'

				}).then(res => {
					if (res.result) {
						this.getReturnBookByCustomerCode();
					} else {
						this.$uil.showMessage({
							text: res.message
						});
					}
				})
			}
		},
		computed: {

		},
		filters: {
			rmb(v) {
				return v + "¥";
			}

		},
		activated() {
			 
		}

	}
</script>

<style>
</style>
